<template>
	<v-dialog v-model="dialog" max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#800000" class="text-lowercase my-n1" icon v-on="on">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-lead-pencil</v-icon>
					</template>
					<span>change design</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
		<v-card-title>
				<span class="subtitle-2">New parameters of 
				<span class="redColor">{{segment.name}} </span> segment
				<span class="redColor">{{ gameId }}  game</span> & 
				<span class="redColor">{{ round }} round</span> </span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
				<v-form v-model="valid" ref="form" validation>
					<v-row>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="segment name"
								v-model="name"
								name="name"
								type="text"
								readonly>
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="quality material 1"
								v-model.number="material1"
								name="material1"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="quality material 2"
								v-model.number="material2"
								name="material2"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="quality material 3"
								v-model.number="material3"
								name="material3"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="quality material 4"
								v-model.number="material4"
								name="material4"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="quality material 5"
								v-model.number="material5"
								name="material5"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="manufacturing quality 1"
								v-model.number="manufacturing1"
								name="manufacturing1"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="manufacturing quality 2"
								v-model.number="manufacturing2"
								name="manufacturing2"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="manufacturing quality 3"
								v-model.number="manufacturing3"
								name="manufacturing3"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="manufacturing quality 4"
								v-model.number="manufacturing4"
								name="manufacturing4"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#800000"
								label="manufacturing quality 5"
								v-model.number="manufacturing5"
								name="manufacturing5"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
					</v-row>
				</v-form>
				</v-container>
				<v-row justify="center" class="error">{{error}}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#800000" text
					class="text-capitalize" 
					@click="closeDialog">
					Close
				</v-btn>
				<v-btn color="#800000" text
					class="text-capitalize"
					:disabled="!valid || Boolean(error)"
					@click="changeSegment"
					>Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

	export default {
		props: ['gameId', 'round', 'segment'],
		data () {
			return	{
				dialog: false,
				valid: false,
				error: '',
				requiredRules: [v => !!v || 'this field is required'],
				numberRules: [
					v => !!v || 'this field is required',
					v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
				],
				name: this.segment.name,
				material1: this.segment.material1,
				material2: this.segment.material2,
				material3: this.segment.material3,
				material4: this.segment.material4,
				material5: this.segment.material5,
				manufacturing1: this.segment.manufacturing1,
				manufacturing2: this.segment.manufacturing2,
				manufacturing3: this.segment.manufacturing3,
				manufacturing4: this.segment.manufacturing4,
				manufacturing5: this.segment.manufacturing5
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			}
		},
		methods: {
		
			onceMore () {
				this.error = ''
			},
			async changeSegment () {

				if (this.$refs.form.validate()) {
					
					if (this.manufacturing1 === this.segment.manufacturing1 &&
						this.manufacturing2 === this.segment.manufacturing2 &&
						this.manufacturing3 === this.segment.manufacturing3 && 
						this.manufacturing4 === this.segment.manufacturing4 &&
						this.manufacturing5 === this.segment.manufacturing5 &&
						this.material1 === this.segment.material1 &&
						this.material2 === this.segment.material2 &&
						this.material3 === this.segment.material3 &&
						this.material4 === this.segment.material4 &&
						this.material5 === this.segment.material5) {

						this.error = 'You didn\'t change any material & manufacturing params of segment'
					}

					else if (!this.gameId || !this.round) {
						this.error = 'Enter game id & round, please'
					}
					else {

						this.segment.material1 = this.material1
						this.segment.material2 = this.material2
						this.segment.material3 = this.material3
						this.segment.material4 = this.material4
						this.segment.material5 = this.material5
						
						this.segment.manufacturing1 = this.manufacturing1
						this.segment.manufacturing2 = this.manufacturing2
						this.segment.manufacturing3 = this.manufacturing3
						this.segment.manufacturing4 = this.manufacturing4
						this.segment.manufacturing5 = this.manufacturing5

						console.log(this.segment)

						try {
							//change segment 
							await this.$store.dispatch('changeSegment', {
								segment: this.segment,
								gameId: this.gameId,
								round: this.round})
							this.closeDialog ()				
						}
						catch (error) {
							throw error
						}
					}
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
				this.designClassic = ''
			}
		}
	}
</script>
<style>
	.error{
		color: white
	}
</style>